module.exports = __webpack_public_path__ + "img/02_map.3ddfddd5.webp";